import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

import AuthHeader from '@/components/blocks/auth-header.vue';
import MainHeader from '@/components/blocks/main-header.vue';
import NavBar from '@/components/blocks/nav-bar.vue';
import { computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

watch([() => route.query.access, () => route.query.refresh], ([access, refresh]) => {
  if (!access || !refresh) return;

  store.dispatch('user/setAuthData', { access, refresh });
  const query = Object.fromEntries(Object.entries(route.query).filter(([key]) => key !== 'access' && key !== 'refresh'));
  router.replace({ ...route, query });
});

const _isLoggedIn = computed(() => store.state.user.isLoggedIn && route.name !== 'ConfirmData');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'body--cabinet': _unref(_isLoggedIn) })
  }, [
    (!_unref(_isLoggedIn))
      ? (_openBlock(), _createBlock(AuthHeader, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(MainHeader),
          _createVNode(NavBar)
        ], 64)),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name
    }))
  ], 2))
}
}

})